module.exports = __webpack_public_path__ + "img/qr-icon-green.a8e57db4.svg";